import { CONTROL_TOWER_API_PATH, CONTROL_TOWER_RELEASE_FLAGS_PATH, controlTowerReleaseFlagsDTOSchema, controlTowerTenantDTOSchema, controlTowerTenantUsageDTOSchema, memberDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const listSchema = listEnvelopeSchema(controlTowerTenantDTOSchema);
const tenantSchema = dataEnvelopeSchema(controlTowerTenantDTOSchema);
const membersSchema = listEnvelopeSchema(memberDTOSchema);
const usageSchema = dataEnvelopeSchema(controlTowerTenantUsageDTOSchema);
const TENANTS_PATH = `${WEB_API_PREFIX}${CONTROL_TOWER_API_PATH}/tenants`;
const boardSchema = dataEnvelopeSchema(controlTowerReleaseFlagsDTOSchema);
const FLAGS_PATH = `${WEB_API_PREFIX}${CONTROL_TOWER_API_PATH}${CONTROL_TOWER_RELEASE_FLAGS_PATH}`;
const overridePath = (key, tenantId) => `${FLAGS_PATH}/${key}/overrides/${encodeURIComponent(tenantId)}`;
export function createControlTowerResource(transport) {
    async function send(method, path, body) {
        const envelope = await transport.request({ method, path, schema: boardSchema, body });
        return envelope.data;
    }
    return {
        releaseFlags: {
            list: () => send('GET', FLAGS_PATH),
            setFallback: (enabled) => send('PUT', `${FLAGS_PATH}/fallback`, { enabled }),
            setDefault: (key, enabled) => send('PUT', `${FLAGS_PATH}/${key}/default`, { enabled }),
            clearDefault: (key) => send('DELETE', `${FLAGS_PATH}/${key}/default`),
            setOverride: (key, tenantId, enabled) => send('PUT', overridePath(key, tenantId), { enabled }),
            clearOverride: (key, tenantId) => send('DELETE', overridePath(key, tenantId)),
        },
        tenants: {
            async list(params = {}) {
                return transport.request({
                    path: TENANTS_PATH,
                    schema: listSchema,
                    query: { page: params.page, pageSize: params.pageSize, sort: params.sort, q: params.q },
                });
            },
            async get(tenantId) {
                const envelope = await transport.request({
                    path: `${TENANTS_PATH}/${encodeURIComponent(tenantId)}`,
                    schema: tenantSchema,
                });
                return envelope.data;
            },
            async listMembers(tenantId, params = {}) {
                return transport.request({
                    path: `${TENANTS_PATH}/${encodeURIComponent(tenantId)}/members`,
                    schema: membersSchema,
                    query: { page: params.page, pageSize: params.pageSize, status: params.status, q: params.q },
                });
            },
            async usage(tenantId) {
                const envelope = await transport.request({
                    path: `${TENANTS_PATH}/${encodeURIComponent(tenantId)}/usage`,
                    schema: usageSchema,
                });
                return envelope.data;
            },
        },
    };
}
//# sourceMappingURL=control-tower.js.map